<script>
import RecognitionDemo from './RecognitionDemo'

export default {
    name: 'DriverLicenseDemo',
    extends: RecognitionDemo,
    data () {
        let fieldList = [
            { name: 'id', label: this.$t('id') },
            { name: 'name', label: this.$t('name') },
            { name: 'dob', label: this.$t('dateOfBirth') },
            { name: 'nation', label: this.$t('nation') },
            { name: 'address', label: this.$t('address') },
            { name: 'place_issue', label: this.$t('placeIssue') },
            { name: 'date', label: this.$t('issueDate') },
            { name: 'doe', label: this.$t('dateOfExpire') },
            { name: 'code', label: this.$t('code') }
        ]
        for (let field of fieldList) {
            field.label = this.$filters.capitalize(field.label)
        }
        return {
            model: {
                id: '0123456789',
                name: 'NGUYỄN VĂN A',
                dob: '01/02/1973',
                nation: 'Việt Nam',
                address: 'CẦU GIẤY, HÀ NỘI',
                place_issue: 'TP. Hồ Chí Minh',
                date: '01/01/2018',
                doe: '01/02/2025',
                code: 'A2 B2'
            },
            imageUrl: '/static/img/blx.jpg',
            demoUrl: process.env.VUE_APP_BASE_FPT_API_URL + process.env.VUE_APP_API_DEMO_DL_RECOGNITION,
            fieldList: fieldList
        }
    }
}
</script>
